<template>
    <div class="form-item">
        <label class="label-caption">Situação S.I.M.</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'ATIVO' },
                { id: 2, descricao: 'INATIVO' },
                { id: 3, descricao: 'EM REGISTRO' },
                { id: 4, descricao: 'INDEFERIDO' },
                { id: 9, descricao: 'SUSPENSO' },
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODAS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', Number(event.target.value));
        }
    }
}
</script>